<template>
  <v-container class="d-flex justify-center">No property.</v-container>
</template>

<script>
export default {
  name: "LoginDesigner",
  
  builder: {
    cat: "Route",
    type: "Login",

    init: function(instance) {},

    getDesc: function(instance) {
      return "Login";
    }
  }
};
</script>
